import * as React from "react";

import { childrenAsArray, valueIsDefined } from "lib/helpers";

interface Props {
  children: React.ReactNode[];
  refs: React.RefObject<HTMLDivElement>[];
  dataVersion: number;
}

interface State {
  currentSection: number;
}

export class NavigableSections extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {
      currentSection: 0,
    };
    this.onScroll = this.onScroll.bind(this);
  }

  public componentDidMount() {
    document.addEventListener("scroll", this.onScroll);
  }

  public componentWillUnmount() {
    document.removeEventListener("scroll", this.onScroll);
  }

  private onScroll() {
    this.props.refs.forEach((x, i) => {
      if (
        valueIsDefined(x.current) &&
        window.scrollY + 100 >= x.current.offsetTop &&
        window.scrollY + 100 < x.current.offsetTop + x.current.clientHeight
      ) {
        this.setState({ currentSection: i });
      }
    });
  }

  public render() {
    const { children, refs, dataVersion } = this.props;

    const sections = (childrenAsArray(children) as JSX.Element[]).filter(
      s => s.props.minimumVersion <= dataVersion,
    );

    return (
      <>
        <div className="navigable-sections">
          <div className="side-menu">
            {sections.map((x, i) => (
              <MenuItem
                id={x.props.className}
                itemTitle={x.props.menuTitle}
                className={`${x.props.className} ${
                  this.state.currentSection === i ? "" : "faded-menu-section"
                }`}
                key={`menu-item-${x.props.className}`}
                externalRef={refs[i]}
              />
            ))}
          </div>
          <div className="body-container">
            <div className="body">{sections}</div>
          </div>
          <div>
            {/* This div is here to counter balance the width of the side menu
                  Solution taken from: https://stackoverflow.com/a/36191570 */}
          </div>
        </div>
      </>
    );
  }
}

function MenuItem(props: {
  id: string;
  itemTitle: string;
  className: string;
  key: string;
  externalRef: React.RefObject<HTMLDivElement>;
}) {
  return (
    <>
      <div
        className={`menu-item-container-outer ${props.className}`}
        onClick={() =>
          window.scrollTo({
            left: 0,
            top: props.externalRef.current.offsetTop,
            behavior: "smooth",
          })
        }
      >
        <div className="menu-item-container-inner">
          <label id={props.id} className="colored-section-separator separator">
            {props.itemTitle}
          </label>
        </div>
      </div>
    </>
  );
}
